var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ModalSlot",
    {
      ref: "sdzModal",
      attrs: {
        title: _vm.getTitle,
        width: _vm.getModalSize,
        "custom-class": "verify-account__in_progress",
        theme: "light",
        "z-index": "999999",
        "hide-confirm-button": "",
        "hide-cancel-button": "",
        "close-icon": "",
      },
      on: { close: _vm.onClose, clickOutside: _vm.onClose },
    },
    [
      _c("div", { staticClass: "verify-account__container" }, [
        _c("p", [
          _vm._v(
            "A sua conta está sendo analisada e em até 48 horas a verificação será concluída."
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "va-actions" },
          [
            _c(
              "button",
              {
                staticClass: "v-btn btn-link",
                on: { click: _vm.abrirZendesk },
              },
              [_vm._v("\n        Falar com suporte\n      ")]
            ),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                staticClass: "white--text v-btn theme--light primary",
                on: { click: _vm.onClose },
              },
              [_vm._v("\n        Ok, entendi\n      ")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }